import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import HeroStrip from "@/components/landing/HeroStrip";
import Marquee from "@/components/landing/Marquee";
import Services from "@/components/landing/Services";
import Manifesto from "@/components/landing/Manifesto";
import Pricing from "@/components/landing/Pricing";
import Gallery from "@/components/landing/Gallery";
import Reviews from "@/components/landing/Reviews";
import CtaFooter from "@/components/landing/CtaFooter";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#FDFBF7] text-[#0F172A] font-body antialiased" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <HeroStrip />
        <Marquee />
        <Services />
        <Manifesto />
        <Pricing />
        <Gallery />
        <Reviews />
        <CtaFooter />
      </main>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}
